import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { Logo } from "./Logo";
import { NAV } from "@/lib/site";
import { WaButton, useGoTo, EASE } from "./ui";

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const goTo = useGoTo();
  const { pathname } = useLocation();
  const onPortrete = pathname === "/portrete";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    goTo(id);
  };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, delay: 1.2, ease: EASE }}
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${scrolled || open ? "bg-[#0B0B0C]/80 backdrop-blur-xl border-b border-[#C9A55C]/15" : "bg-transparent"}`}
      data-testid="site-header"
    >
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 h-20 flex items-center justify-between">
        <Logo onClick={() => go("top")} />
        <nav className="hidden lg:flex items-center gap-9">
          {NAV.map((n) => (
            <button key={n.id} onClick={() => go(n.id)} data-testid={`nav-link-${n.id}`} className="nav-link text-sm text-[#D9D3C7] hover:text-white">
              {n.label}
            </button>
          ))}
          <Link to="/portrete" data-testid="nav-link-portrete" className={`nav-link text-sm ${onPortrete ? "text-[#E3C88A]" : "text-[#D9D3C7] hover:text-white"}`}>
            Portrete me lazer
          </Link>
        </nav>
        <div className="hidden lg:block">
          <WaButton testId="nav-whatsapp-cta" label="Ofertë" className="!py-3 !px-5" />
        </div>
        <button className="lg:hidden text-[#F3EEE4] p-2" onClick={() => setOpen((o) => !o)} data-testid="nav-mobile-toggle" aria-label="Menu">
          {open ? <X /> : <Menu />}
        </button>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.5, ease: EASE }}
            className="lg:hidden overflow-hidden px-5 pb-8"
            data-testid="nav-mobile-menu"
          >
            {NAV.map((n) => (
              <button key={n.id} onClick={() => go(n.id)} data-testid={`nav-mobile-link-${n.id}`} className="block w-full text-left font-display text-3xl text-[#F3EEE4] py-3 border-b border-white/10">
                {n.label}
              </button>
            ))}
            <Link to="/portrete" onClick={() => setOpen(false)} data-testid="nav-mobile-link-portrete" className="block w-full text-left font-display text-3xl text-[#E3C88A] py-3 border-b border-white/10">
              Portrete me lazer
            </Link>
            <WaButton testId="nav-mobile-whatsapp" className="mt-6" />
          </motion.nav>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
